import(/* webpackMode: "eager" */ "/app/apps/marketing/src/app/global-error.tsx");
